// based on https://github.com/silencesys/silentbox

<template>
  <div id="lightbox" v-if="visible">
    <div id="lightbox__background"/>

    <div id="lightbox__content"
         @click.stop="closeSilentboxOverlay"
         v-touch:swipe.left="moveToNextItem"
         v-touch:swipe.right="moveToPreviousItem"
    >
      <div id="lightbox__embed">
        <div id="lightbox__container">
          <img :src="overlayItem.big" :alt="overlayItem.alt" width="auto" height="auto">
        </div>
        <p
          id="lightbox__description"
          v-if="overlayItem.description">
          {{ overlayItem.description }}
        </p>
      </div>
    </div>

    <div
      id="lightbox__close-button"
      role="button"
      tabindex="3"
      @click.stop="closeSilentboxOverlay"
      @keyup.enter="closeSilentboxOverlay"
    >
      <i class="now-ui-icons ui-1_simple-remove"/>
    </div>

    <div id="lightbox__arrow-buttons" v-if="totalItems > 1">
      <i class="arrow arrow-previous now-ui-icons arrows-1_minimal-left"
         role="button"
         tabindex="2"
         @click.stop="moveToPreviousItem"
         @keyup.enter="moveToPreviousItem"
      ></i>
      <i class="arrow arrow-next now-ui-icons arrows-1_minimal-right"
         role="button"
         tabindex="1"
         @click.stop="moveToNextItem"
         @keyup.enter="moveToNextItem"
      ></i>
<!--      <div-->
<!--        class="arrow arrow-previous"-->
<!--        role="button"-->
<!--        tabindex="2"-->
<!--        @click.stop="moveToPreviousItem"-->
<!--        @keyup.enter="moveToPreviousItem"-->
<!--      />-->
<!--      <div-->
<!--        class="arrow arrow-next"-->
<!--        role="button"-->
<!--        tabindex="1"-->
<!--        @click.stop="moveToNextItem"-->
<!--        @keyup.enter="moveToNextItem"-->
<!--      />-->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Lightbox',
    props: {
      overlayItem: {
        type: Object,
        default: () => ({
          src: '',
          description: '',
        }),
      },
      visible: {
        type: Boolean,
        default: false,
      },
      totalItems: {
        type: Number,
        default: 1,
      },
    },
    methods: {
      moveToNextItem() {
        this.$emit('requestNextSilentBoxItem');
      },
      moveToPreviousItem() {
        this.$emit('requestPreviousSilentBoxItem');
      },
      closeSilentboxOverlay() {
        this.$emit('closeSilentboxOverlay');
      },
    },
  };
</script>

<style lang="scss">
  @mixin element($element) {
    &__#{$element} {
      @content;
    }
  }

  // Colours used in silentbox
  $main: #fff;
  $accent: #58e8d2;
  $bg: #000;

  .silentbox-is-opened {
    overflow: hidden;
  }

  #lightbox {
    display: block;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 2000;

    @include element(background) {
      background: rgba($bg, .75);
      backdrop-filter: blur(20px);
      cursor: default;
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    @include element(content) {
      cursor: default;
      display: block;
      height: 100%;
      position: relative;
      width: 100%;
    }

    @include element(embed) {
      bottom: 0;
      cursor: default;
      display: block;
      height: 90%;
      left: 0;
      margin: auto;
      position: absolute;
      right: 0;
      top: 0;
      width: 85%;

      @media (max-width: 900px) {
        width: 100%;
        height: 100%;
      }

      img {
        background-color: $bg;
        bottom: 0;
        box-shadow: 0 0 1.5rem rgba($bg, .45);
        cursor: default;
        display: block;
        left: 0;
        margin: auto;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    @include element(container) {
      cursor: default;
      height: 100%;
      margin: 0;
      position: relative;
      text-align: center;
      width: 100%;
    }

    @include element(description) {
      display: block;
      padding-top: 1rem;
      text-align: center;
      color: $main;
    }

    @include element(close-button) {
      color: $main;
      cursor: pointer;
      position: absolute;
      right: 2rem;
      top: 2rem;
      padding: 0.5rem 0.7rem;
      font-size: 24px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 0.1875rem;
      }

      &:focus {
        outline: none;
      }

      @media (max-width: 576px) {
        right: 0.1rem;
        top: 0.1rem;
        padding: 0.2rem 0.2rem;
      }
    }

    @include element(arrow-buttons) {
      .arrow {
        cursor: pointer;
        position: absolute;
        padding: 0.5rem 0.7rem;
        font-size: 28px;
        color: $main;
        top: 50%;
        transform: translateY(-50%);

        &:hover {
          outline: none;
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 0.1875rem;
        }

        &:focus {
          outline: none;
        }

        @media (max-width: 576px) {
          padding: 0.5rem 0.2rem;
        }
      }
      .arrow-previous {
        left: 2rem;

        @media (max-width: 576px) {
          left: 0.1rem;
        }
      }
      .arrow-next {
        right: 2rem;

        @media (max-width: 576px) {
          right: 0.1rem;
        }
      }
    }
  }
</style>
